<template>
  <v-main>
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex xs12 sm8 md6 lg6>
          <v-card class="elevation-2">
            <v-card-title>
              <v-icon>check</v-icon>
              Email Verification Successful</v-card-title>
            <v-card-text></v-card-text>
            <v-card-actions>
              <v-btn block class="blue--text" outlined @click="routeToSignIn">
                Sign back in
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-main>
</template>
<script>
export default {
  data: () => ({

  }),
  computed: {
    user () {
      return this.$store.getters.user
    },
    error () {
      return this.$store.getters.error
    },
    loading () {
      return this.$store.getters.loading
    }
  },
  methods: {
    routeToSignIn () {
      if (this.user) {
        this.$router.push('/')
      } else {
        this.$router.push('/login')
      }
    },
    onDismissed () {
      this.$store.dispatch('clearError')
    }
  }

}
</script>

